export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Medium.ef8bb094.woff2";